/**
 * Local development entry point.
 *
 * In production, `ModuleApp` is loaded as a remote module by the xplatform
 * shell. This standalone entry provides its own `XPlatformProvider` (the shared
 * TecAlliance theme) so the module can still be developed in isolation on
 * port 5002.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { XPlatformProvider } from "@xplatform/design-system";
import "./styles/layers.css";
import "@mantine/core/styles.layer.css";
import "@xplatform/design-system/styles.layer.css";
import "./config/i18n";
import "./index.scss";
import ModuleApp from "./ModuleApp";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <XPlatformProvider>
    <BrowserRouter>
      <ModuleApp />
    </BrowserRouter>
  </XPlatformProvider>,
);
